module.exports = __webpack_public_path__ + "static/media/meglive.659058df.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/image/scene/meglive.mp4
// module id = 760
// module chunks = 0